import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (e) { console.warn("payment status poll failed (will retry):", e); }
      if (++tries < 6) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-10 max-w-md w-full text-center" data-testid="payment-success-page">
        {status === "pending" && (<>
          <Loader2 className="w-12 h-12 mx-auto text-blue-600 animate-spin" />
          <h1 className="mt-4 text-2xl font-bold tracking-tight">Confirming your payment…</h1>
          <p className="text-sm text-slate-500 mt-2">This takes a few seconds.</p>
        </>)}
        {status === "paid" && (<>
          <div className="w-14 h-14 mx-auto rounded-full bg-emerald-50 flex items-center justify-center"><Check className="w-7 h-7 text-emerald-600" /></div>
          <h1 className="mt-4 text-2xl font-bold tracking-tight">You're subscribed</h1>
          <p className="text-sm text-slate-500 mt-2">ASFA stays live for your business. Thank you.</p>
          <Link to="/app"><Button data-testid="payment-success-continue" className="mt-6 rounded-xl bg-blue-600 hover:bg-blue-700">Back to dashboard</Button></Link>
        </>)}
        {(status === "error" || status === "timeout") && (<>
          <XCircle className="w-12 h-12 mx-auto text-amber-500" />
          <h1 className="mt-4 text-2xl font-bold tracking-tight" data-testid="payment-error-heading">
            {status === "error" ? "Invalid payment link" : "Still processing"}
          </h1>
          <p className="text-sm text-slate-500 mt-2">
            {status === "error"
              ? "No payment session was found. If you just paid, contact support."
              : "Payment may take a moment to confirm. Check Settings → Billing shortly."}
          </p>
          <Link to="/app/settings"><Button data-testid="payment-success-settings" className="mt-6 rounded-xl bg-blue-600 hover:bg-blue-700">Go to settings</Button></Link>
        </>)}
      </div>
    </div>
  );
}
